import './signup-modal.scss';

import * as React from 'react';
import { ResponsiveModalContainer, StorableDataKeys, LocalStorage } from '@weddingspot/ws-core-components';
import SignupForm from './SignupForm';

interface OwnProps {
    // Props passed on instantiation
    showModal: boolean;
    handleModalClosed?: () => void;
    onSubmitSuccess?: () => void;
}

import { FormData as VendorFormData } from './SignupForm';
import { tokenizeFullName } from '../../utils/string';
import { clone } from '../../utils/fp';
import { VendorSignupData } from '../../types';
import { AuthProvider } from '@weddingspot/ws-api-client';
import { change, reset, SubmissionError } from 'redux-form';
import { Dispatch } from 'redux';
import * as analytics from '@weddingspot/ws-analytics';
const { logEvent, AnalyticsEvent } = analytics;

const LANDING_PAGE_REG_SOURCE = 'Landing Page';

export default class SignupModal extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        if (!!this.props.handleModalClosed) {
            this.props.handleModalClosed();
        }
    }

    cleanPhoneMask(value?: string) {
        if (!value) {
            return '';
        }

        // Try to strip out any remaining mask characters left in the input mask
        const re = /(\d{3}-\d{3}-\d{4})( ext\. (\d{0,4}\_*))?$/;
        let match = value.match(re) || [];
        let main = match[1];
        let ext = match[2];
        let extDigits = match[3];

        if (ext !== undefined) {
            extDigits = extDigits.replace(/_/g, '');
            if (extDigits.length > 0) {
                return `${main} ext. ${extDigits}`;
            }
            return main;
        }

        return value;
    }

    public render() {
        return (
            <div className='signup-modal signup-base-modal'>
                <ResponsiveModalContainer
                    show={this.props.showModal}
                    headerContent={`Sign up for Wedding Spot`}
                    handleClickModalBackground={this.closeModal}
                    handleClickModalClose={this.closeModal}
                >
                    <div className='signup-modal-content'>
                        <div className='signup-form'>
                            <SignupForm
                                onSubmit={(data: VendorFormData, dispatch: Dispatch<any>) => {
                                    const postData = clone(data) as VendorSignupData;
                                    // @ts-ignore
                                    postData.grecaptcha_response =  grecaptcha.getResponse(LocalStorage.getItem(StorableDataKeys.RECAPTCHA_WIDGET_ID_VENDOR_SIGNUP_FORM));
                                    const nameTokens = tokenizeFullName(postData.name);
                                    if (!nameTokens) {
                                        // This shouldn't happen, because validation
                                        return;
                                    }
                                    const [firstName, lastName] = nameTokens;
                                    postData.first_name = firstName;
                                    postData.last_name = lastName;

                                    // Clean up any remaining extension masks
                                    postData.phone_number = this.cleanPhoneMask(postData.phone_number);

                                    postData.reg_source = LANDING_PAGE_REG_SOURCE;

                                    return new Promise((resolve, reject) => {
                                        AuthProvider.vendorSignup(postData)
                                            .then((response: any) => {
                                                logEvent(AnalyticsEvent.EVTNM_SHOWN_SIGN_UP_SUCCESS, {});
                                                if (!!this.props.onSubmitSuccess) {
                                                    this.props.onSubmitSuccess();
                                                } else if (!!this.props.handleModalClosed) {
                                                    this.props.handleModalClosed();
                                                    //@ts-ignore
                                                    grecaptcha.reset(LocalStorage.getItem(StorableDataKeys.RECAPTCHA_WIDGET_ID_VENDOR_SIGNUP_FORM));
                                                    //@ts-ignore
                                                    if(!grecaptcha.getResponse(LocalStorage.getItem(StorableDataKeys.RECAPTCHA_WIDGET_ID_VENDOR_SIGNUP_FORM))){
                                                        document.getElementById('vendor-signup-form-hidden-input')?.click();
                                                    }
                                                }
                                                dispatch(reset('SignupForm'));
                                                dispatch(reset('MiniForm'));
                                            })
                                            .catch((response: any) => {
                                                if (
                                                    response &&
                                                    response.detail &&
                                                    response.detail.content &&
                                                    response.detail.content.errors
                                                ) {
                                                    let errors = response.detail.content.errors;
                                                    logEvent(AnalyticsEvent.EVTNM_ERROR_SIGN_UP_ERROR, {
                                                        Errors: errors,
                                                    });
                                                    reject(
                                                        new SubmissionError({
                                                            ...errors,
                                                        })
                                                    );
                                                    //@ts-ignore
                                                    grecaptcha.reset(LocalStorage.getItem(StorableDataKeys.RECAPTCHA_WIDGET_ID_VENDOR_SIGNUP_FORM));
                                                    //@ts-ignore
                                                    if(!grecaptcha.getResponse(LocalStorage.getItem(StorableDataKeys.RECAPTCHA_WIDGET_ID_VENDOR_SIGNUP_FORM))){
                                                        document.getElementById('vendor-signup-form-hidden-input')?.click();
                                                    }
                                                }
                                            });
                                    });
                                }}
                            />
                        </div>
                    </div>
                </ResponsiveModalContainer>
            </div>
        );
    }
}
